/* Hogan landingspagina — Dames/Heren-tabs + CTA-tracking.
 *
 * Bewust klein en zonder dependencies: dit is een advertentie-landingspagina, dus
 * elke kB telt. De FAQ gebruikt native <details> en heeft hier niets nodig.
 *
 * Progressive enhancement: zonder JS zijn de tabs gewone links naar de collectie
 * en blijft het eerste paneel zichtbaar. Niets breekt.
 */
(function () {
  'use strict';

  function initTabs(nav) {
    var tabs = Array.prototype.slice.call(nav.querySelectorAll('[data-hogan-tab]'));
    if (tabs.length < 2) return;

    var section = nav.closest('section');
    if (!section) return;

    function panelFor(index) {
      return section.querySelector('[data-hogan-panel="' + index + '"]');
    }

    function select(index, focusTab) {
      tabs.forEach(function (tab) {
        var i = tab.getAttribute('data-hogan-tab');
        var active = i === String(index);
        tab.classList.toggle('on', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        // Alleen de actieve tab in de tabvolgorde — standaard tabs-patroon.
        tab.setAttribute('tabindex', active ? '0' : '-1');
        var panel = panelFor(i);
        if (panel) panel.hidden = !active;
      });

      // Onderste knop volgt de actieve tab: neem de href (= collectie-URL) van de
      // actieve tab over. De tab-anchor linkt al naar zijn collectie, dus dat is de
      // bron. '#' (geen collectie gekozen) laten we staan zodat we niets kapotmaken.
      var followCta = section.querySelector('[data-hogan-cta-follow]');
      if (followCta) {
        var activeTab = nav.querySelector('[data-hogan-tab="' + index + '"]');
        var href = activeTab && activeTab.getAttribute('href');
        if (href && href !== '#') followCta.setAttribute('href', href);
      }

      if (focusTab) {
        var current = nav.querySelector('[data-hogan-tab="' + index + '"]');
        if (current) current.focus();
      }
    }

    nav.setAttribute('role', 'tablist');

    tabs.forEach(function (tab, order) {
      tab.setAttribute('tabindex', order === 0 ? '0' : '-1');

      tab.addEventListener('click', function (event) {
        // Zonder JS zou dit naar de collectiepagina navigeren; hier wisselen we in-page.
        event.preventDefault();
        select(tab.getAttribute('data-hogan-tab'), false);
      });

      // Pijltjestoetsen tussen tabs (briefing §9: toetsenbord-bedienbaar).
      tab.addEventListener('keydown', function (event) {
        var step = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
        if (!step) return;
        event.preventDefault();
        var next = (order + step + tabs.length) % tabs.length;
        select(tabs[next].getAttribute('data-hogan-tab'), true);
      });
    });
  }

  /* CTA-tracking voor advertentiemeting (briefing §9).
   * Stuurt naar GA4 en Meta als die aanwezig zijn — nooit crashen als ze ontbreken. */
  function initTracking(root) {
    root.addEventListener('click', function (event) {
      var el = event.target.closest('[data-hogan-track]');
      if (!el) return;
      var label = el.getAttribute('data-hogan-track');

      if (typeof window.gtag === 'function') {
        window.gtag('event', 'hogan_cta_click', {
          cta: label,
          link_url: el.getAttribute('href') || ''
        });
      }
      if (typeof window.fbq === 'function') {
        window.fbq('trackCustom', 'HoganCtaClick', { cta: label });
      }
    });
  }

  /* Desktop-/mobielvideo's (hogan-media snippet).
   *
   * Een <video> met data-hogan-video heeft nog geen src: die staat in data-src.
   * CSS bepaalt welke variant zichtbaar is (breekpunt 767px); wij geven alleen de
   * zichtbare video zijn src. Zo haalt een telefoon nooit de desktopvideo binnen.
   * Het media-attribuut in <video> wordt door browsers genegeerd, dus dit moet in JS.
   *
   * offsetParent === null betekent hier "verborgen door display:none".
   */
  function loadVisibleVideos(root) {
    root.querySelectorAll('video[data-hogan-video][data-src]').forEach(function (video) {
      var hidden = video.offsetParent === null;
      if (hidden || video.getAttribute('src')) return;

      video.setAttribute('src', video.getAttribute('data-src'));
      video.load();
      // Autoplay kan geweigerd worden (bv. spaarstand); poster blijft dan staan.
      var attempt = video.play();
      if (attempt && typeof attempt.catch === 'function') attempt.catch(function () {});
    });
  }

  function initVideos(root) {
    loadVisibleVideos(root);

    // Bij het passeren van het breekpunt (rotatie, venster slepen) de andere
    // variant alsnog laden. Elke video krijgt zijn src maar één keer.
    if (window.matchMedia) {
      var mq = window.matchMedia('(max-width: 767px)');
      var onChange = function () {
        loadVisibleVideos(root);
      };
      if (mq.addEventListener) mq.addEventListener('change', onChange);
      else if (mq.addListener) mq.addListener(onChange);
    }
  }

  /* Play/pauze-knop op de iconen-tegels.
   *
   * De knop ligt boven de uitgerekte tegel-link, dus een klik hier navigeert niet.
   * Er kunnen twee video's in een tegel zitten (desktop + mobiel); we pakken de
   * zichtbare. Het icoon volgt de echte staat van de video via play/pause-events,
   * zodat het klopt ook als autoplay geweigerd wordt.
   */
  function initPlayToggles(root) {
    root.querySelectorAll('[data-hogan-playtoggle]').forEach(function (btn) {
      var box = btn.closest('.box');
      if (!box) return;

      function currentVideo() {
        var videos = box.querySelectorAll('video');
        for (var i = 0; i < videos.length; i++) {
          if (videos[i].offsetParent !== null) return videos[i];
        }
        return videos[0] || null;
      }

      function sync() {
        var video = currentVideo();
        if (!video) return;
        var playing = !video.paused && !video.ended;
        btn.classList.toggle('is-playing', playing);
        btn.setAttribute(
          'aria-label',
          playing ? btn.getAttribute('data-label-pause') : btn.getAttribute('data-label-play')
        );
      }

      btn.addEventListener('click', function (event) {
        event.preventDefault();
        var video = currentVideo();
        if (!video) return;
        if (video.paused) {
          // Video's krijgen hun src pas als ze zichtbaar zijn (zie initVideos);
          // is dat nog niet gebeurd, doe het hier alsnog.
          if (!video.getAttribute('src') && video.getAttribute('data-src')) {
            video.setAttribute('src', video.getAttribute('data-src'));
            video.load();
          }
          var attempt = video.play();
          if (attempt && typeof attempt.catch === 'function') attempt.catch(function () {});
        } else {
          video.pause();
        }
        sync();
      });

      box.querySelectorAll('video').forEach(function (video) {
        video.addEventListener('play', sync);
        video.addEventListener('pause', sync);
      });

      sync();
    });
  }

  function init() {
    var root = document.querySelector('.hogan-lp');
    if (!root) return;
    root.querySelectorAll('[data-hogan-tabs]').forEach(initTabs);
    initVideos(root);
    initPlayToggles(root);
    initTracking(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme-editor: secties worden herladen zonder page reload.
  document.addEventListener('shopify:section:load', init);
})();
